import { render, staticRenderFns } from "./google_food_export.vue?vue&type=template&id=0e7e0d7c&scoped=true&"
import script from "./google_food_export.vue?vue&type=script&lang=js&"
export * from "./google_food_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e0d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7e0d7c')) {
      api.createRecord('0e7e0d7c', component.options)
    } else {
      api.reload('0e7e0d7c', component.options)
    }
    module.hot.accept("./google_food_export.vue?vue&type=template&id=0e7e0d7c&scoped=true&", function () {
      api.rerender('0e7e0d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/google_food/google_food_export.vue"
export default component.exports